import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { MdAttachMoney, MdOutlineStorefront } from "react-icons/md";
import { TbFileDescription } from "react-icons/tb";
import { PurpleButton } from "../../../components/buttons/purpleButton";
import { DescontoCard } from "../../../components/descontoCard";
import { ImageUpload } from "../../../components/imageUpload";
import { InputWithIcon } from "../../../components/inputs/inputWithIcon";
import { useUploadingState } from "../../../hooks/useUploadingState";
import { IDescontoInput } from "../../../model/descontos";
import descontosService from "../../../services/descontosService";
import { AddConveniadoForm, AddDescontoWrapper } from "./styles";

export const AdicionarDesconto = () => {
  const toast = useRef<Toast>(null);

  const ERROR_MESSAGE =
    "Ocorreu um erro ao adicionar desconto. Por favor, tente novamente.";
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [endereco, setEndereco] = useState("");
  const [desconto, setDesconto] = useState("");
  const [imagem, setImagem] = useState("");
  const { isUploading, uploadingRef, onUploadingChange } =
    useUploadingState();

  function createDiscount() {
    if (uploadingRef.current) {
      showUploadInProgressWarning();
      return;
    }

    if (isRequiredFieldsEmpty()) {
      return;
    }

    const store: IDescontoInput = {
      nome: nome.trim(),
      endereco: endereco.trim(),
      dataCriacao: new Date().toISOString(),
      descricao: descricao.trim(),
      contato: "",
      desconto: desconto.trim(),
      imagem: imagem.trim(),
    };

    descontosService
      .createDesconto(store)
      .then((res) => {
        if (res.status === 200) {
          const message = `Desconto ${nome} adicionado com sucesso!`;
          showToastMessage("success", message);
          cleanStates();
        } else {
          showToastMessage("error", ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        showToastMessage("error", getApiErrorMessage(error));
      });
  }

  function getApiErrorMessage(error: any): string {
    const objects = error?.response?.data?.objects;
    if (Array.isArray(objects) && objects.length > 0) {
      return objects
        .map((item: { name?: string; userMessage?: string }) =>
          item.userMessage
            ? `${item.name ?? "campo"}: ${item.userMessage}`
            : null
        )
        .filter(Boolean)
        .join(" | ");
    }

    return error?.response?.data?.userMessage || ERROR_MESSAGE;
  }

  function isRequiredFieldsEmpty(): boolean {
    if (imagem.length > 255) {
      showInfoToastMessage("A imagem não pode ultrapassar 255 caracteres.");
      return true;
    }

    if (descricao.length > 255) {
      showInfoToastMessage("A descrição não pode ultrapassar 255 caracteres.");
      return true;
    }

    const requiredFields = [nome, endereco, imagem, descricao];
    const isEmpty = requiredFields.some((field) => field.trim().length === 0);
    if (isEmpty) {
      showInfoToastMessage("Por favor, preencha todos os campos obrigatórios.");
    }

    return isEmpty;
  }

  function cleanStates() {
    const states = [setNome, setDescricao, setDesconto, setImagem, setEndereco];
    states.forEach((state) => state(""));
  }

  function showToastMessage(type: "success" | "error", detail: string) {
    toast.current?.show({
      severity: type,
      summary: type === "error" ? "Erro" : "Sucesso",
      detail,
      life: 3000,
    });
  }

  function showInfoToastMessage(detail: string) {
    toast.current?.show({
      severity: "info",
      summary: "Info",
      detail,
      life: 3000,
    });
  }

  function showUploadInProgressWarning() {
    toast.current?.show({
      severity: "warn",
      summary: "Atenção",
      detail: "Aguarde o envio da imagem terminar.",
      life: 3000,
    });
  }

  return (
    <>
      <Toast ref={toast} />
      <AddDescontoWrapper>
        <AddConveniadoForm>
          <div
            style={{
              margin: "24px 0px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2 style={{ width: "fit-content" }}>Adicionar Desconto</h2>
          </div>

          <InputWithIcon
            required={true}
            title="Nome"
            icon={<MdOutlineStorefront size={24} color="#CE7035" />}
            placeholder="Digite o nome do desconto"
            value={nome}
            onChange={setNome}
          />

          <InputWithIcon
            required={true}
            title="Endereço"
            icon={<MdOutlineStorefront size={24} color="#CE7035" />}
            placeholder="Digite o endereço"
            value={endereco}
            onChange={setEndereco}
          />

          <ImageUpload
            required={true}
            label="Imagem"
            category="DESCONTOS"
            value={imagem}
            onChange={setImagem}
            onUploadingChange={onUploadingChange}
          />

          <InputWithIcon
            title="Desconto"
            icon={<MdAttachMoney size={24} color="#CE7035" />}
            placeholder="Digite o texto de desconto"
            value={desconto}
            onChange={setDesconto}
          />

          <InputWithIcon
            required={true}
            title="Descrição"
            icon={<TbFileDescription size={24} color="#CE7035" />}
            placeholder="Digite a descrição do desconto"
            value={descricao}
            onChange={setDescricao}
          />
        </AddConveniadoForm>
        <div style={{ maxHeight: "502px" }}>
          <DescontoCard
            desconto={desconto}
            imagem={imagem}
            endereco={endereco}
            nome={nome}
            descricao={descricao}
          ></DescontoCard>
        </div>
        <PurpleButton
          title="Adicionar"
          onClick={() => createDiscount()}
          disabled={isUploading}
        />
      </AddDescontoWrapper>
    </>
  );
};
